/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToRem, pxToEm, pxToEmWithBaseline, mediaQuery, nthChildIterator} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
  generalsection: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    },
    '& .tablesectionview': {
      borderCollapse: 'separate',
      borderSpacing: `0px ${pxToRem(16)}`,
      display: 'table',
      width: '100%',
      '& > .sectiongroup': {
        display: 'table-cell',
        [mediaQuery.customizeThinnest]: {
          display: 'table-row'
        }
      }
    },
    '& .field.name-loginFormUrl': {
      width: '100%',
      maxWidth: pxToRem(328)
    },
    '& .name-controls': {
      display: 'flex',
      flexWrap: 'wrap',
      '& .control': {
        width: pxToEm(172),
        marginTop: pxToEm(16)
      },
      '&.advance': {
        '& .control': {
          width: pxToEm(152)
        }
      }
    },
    '& .imageuploader': {
      marginTop: pxToEm(8)
    },
    // TODO: Abstract COPY component into IUI (maybe replace existing CopyField if it is not used)
    // It is also used in code tab of commenting config
    '& .group': {
      '& .field': {
        maxWidth: pxToEmWithBaseline({ value: 513, fontSizeBaseline: 16 }),
        marginTop: pxToEmWithBaseline({ value: 12, fontSizeBaseline: 16 }),
        display: 'block',
        '& .textfield': {
          fontSize: pxToEm(14)
        }
      },
      '& .button': {
        display: 'block',
        marginTop: pxToEmWithBaseline({ value: 12, fontSizeBaseline: 14 }),
        fontSize: pxToEm(14),
        width: pxToEmWithBaseline({ value: 80, fontSizeBaseline: 14 }),
        height: pxToEmWithBaseline({ value: 48, fontSizeBaseline: 14 })
      }
    }
  }
});
